import app from 'flarum/forum/app';
import { extend, override } from 'flarum/common/extend';
import CommentPost from 'flarum/forum/components/CommentPost';

// A post only re-renders when its subtree checks change. FoF Polls checks the saved votes, so picking an
// answer (before pressing Vote) or "View result" would never show; this counter is bumped on those.
let pollTick = 0;
const bump = () => {
  pollTick++;
};

/**
 * Blind-style polls (FoF Polls):
 * - feed cards: a "Poll · N Participants" bar under the excerpt
 * - discussion page: a bordered poll card headed "Poll · N Participants" + "Select only one answer",
 *   radio-style options, a full-width Vote button (pick, then vote) and "View result" before voting.
 * Only styling and small state tweaks; voting itself is FoF Polls' own.
 */
const participants = n => n.toLocaleString() + (n === 1 ? ' Participant' : ' Participants');
export default function vouchaPolls() {
  // ---------- feed card ----------
  extend('flarum/forum/components/DiscussionListItem', 'infoItems', function (items) {
    const d = this.attrs.discussion;
    if (!d || !d.attribute('hasPoll')) return;
    const n = d.attribute('vouchaPollVoters');
    items.add('voucha-poll', m("span", {
      className: "VouchaPollBar"
    }, m("i", {
      className: "fas fa-square-poll-vertical",
      "aria-hidden": "true"
    }), m("span", {
      className: "VouchaPollBar-label"
    }, "Poll"), typeof n === 'number' ? m("span", {
      className: "VouchaPollBar-count"
    }, participants(n)) : null), -50);
  });
  extend(CommentPost.prototype, 'oninit', function () {
    this.subtree.check(() => pollTick);
  });

  // ---------- voting: choose an answer, then press Vote ----------
  extend('ext:fof/polls/forum/states/PollState', 'init', function () {
    if (!this.poll.hasEnded()) this.useSubmitUI = true;
  });
  extend('ext:fof/polls/forum/states/PollState', 'changeVote', bump);
  extend('ext:fof/polls/forum/states/PollState', 'submit', function (promise) {
    bump();
    if (promise && promise.finally) {
      promise.finally(() => {
        bump();
        m.redraw();
      });
    }
  });
  // The Vote button stays visible while the member can vote (disabled until an answer is picked)
  override('ext:fof/polls/forum/states/PollState', 'showButton', function (original) {
    return this.useSubmitUI && this.showCheckMarks && !this.hasVoted() || original();
  });

  // "Select only one answer" in the header says it already
  extend('ext:fof/polls/forum/components/PostPoll', 'infoItems', function (items) {
    if (items.has('max-votes')) items.remove('max-votes');
  });

  // ---------- discussion page card ----------
  extend('ext:fof/polls/forum/components/PostPoll', 'view', function (vnode) {
    if (!vnode || !vnode.children) return;
    const poll = this.attrs.poll;
    const state = this.state;
    const post = this.attrs.post;
    const discussion = post && post.discussion && post.discussion();
    const sameAsTitle = discussion && (discussion.title() || '').trim().toLowerCase() === (poll.question() || '').trim().toLowerCase();
    const max = state.getMaxVotes();
    const voted = state.hasVoted();
    const canSee = typeof poll.voteCount() === 'number';
    const showResults = voted || poll.hasEnded() || this.vouchaShowResults;
    vnode.attrs.className = [vnode.attrs.className, 'VouchaPoll', sameAsTitle && 'VouchaPoll--sameTitle', !showResults && 'VouchaPoll--hideResults'].filter(Boolean).join(' ');
    vnode.children.unshift(m("div", {
      className: "VouchaPollHead"
    }, m("span", {
      className: "VouchaPollHead-label"
    }, m("i", {
      className: "fas fa-square-poll-vertical",
      "aria-hidden": "true"
    }), " Poll"), canSee ? m("span", {
      className: "VouchaPollHead-count"
    }, participants(poll.voteCount())) : null, poll.hasEnded() ? m("span", {
      className: "VouchaPollHead-ended"
    }, "Closed") : null), !voted && !poll.hasEnded() ? m("div", {
      className: "VouchaPollHint"
    }, max > 1 ? 'Select up to ' + max + ' answers' : 'Select only one answer') : null);
    if (canSee && !voted && !poll.hasEnded()) {
      vnode.children.push(m("button", {
        type: "button",
        className: "VouchaPollResults",
        onclick: () => {
          this.vouchaShowResults = !this.vouchaShowResults;
          bump();
        }
      }, this.vouchaShowResults ? 'Hide result' : 'View result'));
    }
  });
}